<template>
    <table class="w-full">
        <thead class="border-b border-gray-400">
            <th class="p-2 text-left"># of Decks Completed</th>
            <th class="w-32 p-2 text-left">
                Points <span class="hidden md:inline-block">earned</span>
            </th>
            <th class="w-12 p-2 text-right"></th>
        </thead>
        <tbody>
            <template v-for="threshold in tableThresholds">
                <tr>
                    <td class="p-2 text-left">
                        {{ threshold }}
                        {{ threshold !== 1 ? "decks" : "deck" }}
                    </td>
                    <td class="p-2 text-center">
                        {{ threshold <= stacksCompleted ? "1" : "0" }}/1
                    </td>
                    <td class="flex justify-end p-2">
                        <div v-if="threshold <= stacksCompleted">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="12" cy="12" r="12" fill="#1F9294" />
                                <g clip-path="url(#clip0_1325_27517)">
                                    <path
                                        d="M10.9197 15.5195C10.7218 15.5726 10.5084 15.512 10.3869 15.3469C10.118 14.9829 9.92007 14.5715 9.8034 14.1342C9.58505 13.3193 9.66334 12.4958 9.97118 11.7765C10.0175 11.6683 10.1063 11.5861 10.201 11.5168C10.3985 11.3725 10.5513 11.1664 10.6501 10.9353C10.888 10.3773 11.2398 9.87504 11.6829 9.46074C11.9717 9.19172 12.1923 8.84713 12.2387 8.45589C12.2714 8.18173 12.2515 7.90383 12.18 7.63714L12.101 7.34238C12.0762 7.24976 12.0892 7.15107 12.1371 7.06802C12.1851 6.98498 12.264 6.92438 12.3567 6.89956C12.6345 6.82511 12.9306 6.86408 13.1797 7.00792C13.4289 7.15176 13.6107 7.38868 13.6851 7.66655C13.8289 8.20298 13.8439 8.74345 13.75 9.25524C13.6957 9.54826 13.9598 9.83886 14.2475 9.76175L15.7032 9.37171C16.1809 9.24369 16.6955 9.45219 16.8736 9.91403C16.9472 10.1049 17.0113 10.3014 17.0656 10.5039C17.4089 11.7776 17.3048 13.1305 16.7705 14.3366C16.65 14.6095 16.4019 14.7992 16.1141 14.8763L14.244 15.3774C14.0191 15.4377 13.7854 15.4614 13.5527 15.4479L11.9729 15.3521C11.7401 15.3383 11.5067 15.3621 11.2815 15.4226L10.9197 15.5195ZM7.54616 12.5441C7.46432 13.2651 7.51921 13.995 7.70795 14.6957C7.85563 15.2492 8.0847 15.7777 8.38767 16.2639C8.61479 16.6272 9.06312 16.7656 9.47709 16.6547L9.89944 16.5416C10.1067 16.486 10.1726 16.2198 10.0309 16.0581C9.59261 15.5583 9.27556 14.964 9.10445 14.3215C8.89134 13.5262 8.91373 12.7231 9.12855 11.9863C9.19235 11.7681 8.99585 11.5432 8.77606 11.6021L8.28666 11.7333C7.89923 11.8371 7.59208 12.1455 7.54616 12.5441Z"
                                        fill="white"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1325_27517">
                                        <rect
                                            width="11.57"
                                            height="11.57"
                                            fill="white"
                                            transform="translate(5.09082 7.72266) rotate(-15)"
                                        />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </td>
                </tr>
            </template>
        </tbody>
    </table>
</template>
<script>
export default {
    name: "StudentReadinessScoreDetailsFlashcardStacksCompletedTable",
    props: {
        stacksCompleted: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            tableThresholds: [1, 5, 10, 15, 20, 25, 30, 35],
        };
    },
};
</script>
